import React, { useState, useEffect } from 'react';
import './BookmarksPanel.css';

const BookmarksPanel = ({ onClose, onJumpTo }) => {
  const [bookmarks, setBookmarks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBookmarks();
  }, []);

  const fetchBookmarks = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/chat/rooms/bookmarks', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = await response.json();
      if (data.success) {
        setBookmarks(data.data.bookmarks);
      }
    } catch (error) {
      console.error('Failed to fetch bookmarks:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveBookmark = async (messageId) => {
    try {
      const response = await fetch(`/api/chat/rooms/messages/${messageId}/bookmark`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.ok) {
        setBookmarks(bookmarks.filter(b => b.messageId._id !== messageId));
      }
    } catch (error) {
      console.error('Failed to remove bookmark:', error);
    }
  };

  return (
    <div className="bookmarks-panel-overlay" onClick={onClose}>
      <div className="bookmarks-panel" onClick={(e) => e.stopPropagation()}>
        <div className="panel-header">
          <h3>🔖 Bookmarked Messages</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="bookmarks-list">
          {loading ? (
            <div className="loading">Loading bookmarks...</div>
          ) : bookmarks.length === 0 ? (
            <div className="no-bookmarks">
              <p>No bookmarked messages yet</p>
              <small>Click the bookmark icon on any message to save it</small>
            </div>
          ) : (
            bookmarks.map(bookmark => (
              <div key={bookmark._id} className="bookmark-item">
                <div className="bookmark-header">
                  <span className="bookmark-author">{bookmark.messageId.senderId.username}</span>
                  <span className="bookmark-room">#{bookmark.roomId.name}</span>
                  <button 
                    className="remove-bookmark"
                    onClick={() => handleRemoveBookmark(bookmark.messageId._id)}
                  >
                    ×
                  </button>
                </div>
                <div className="bookmark-content">{bookmark.messageId.content}</div>
                {bookmark.note && (
                  <div className="bookmark-note">
                    <strong>Note:</strong> {bookmark.note}
                  </div>
                )}
                {bookmark.tags && bookmark.tags.length > 0 && (
                  <div className="bookmark-tags">
                    {bookmark.tags.map((tag, idx) => (
                      <span key={idx} className="tag">{tag}</span>
                    ))}
                  </div>
                )}
                <div className="bookmark-date">
                  Saved on {new Date(bookmark.createdAt).toLocaleDateString()}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default BookmarksPanel;
